import { DocumentSelection } from "../documents/document-selection";
import { DocumentationType, MeetingLocationType, MeetingOnlineType } from "../documents/document-enums";
import { Address } from "../address/address";

export class AnnualStatementSettingsData {
  generateAutomatically: boolean;
  documentTypeToGenerate: DocumentationType;
  addSignatoryToCompanyStatement: boolean;
  meetingLocationType: MeetingLocationType;
  meetingOnlineType?: MeetingOnlineType | null;
  otherAddress?: Address | null;
  documentSelectionFiles: DocumentSelection[];

  constructor(data: Partial<AnnualStatementSettingsData> = {}) {
    this.generateAutomatically = data.generateAutomatically ?? true;
    this.documentTypeToGenerate = data.documentTypeToGenerate ?? DocumentationType.Minutes;
    this.addSignatoryToCompanyStatement = data.addSignatoryToCompanyStatement ?? true;
    this.meetingLocationType = data.meetingLocationType ?? MeetingLocationType.Registered;
    this.meetingOnlineType = data.meetingOnlineType ?? null;
    this.otherAddress = data.otherAddress ?? null;
    this.documentSelectionFiles = data.documentSelectionFiles ?? [];
  }
}
